export const MUNICIPALITY_NAMES = {
  "VAR01": "Аврен",
  "BGS01": "Айтос",
  "VAR02": "Аксаково",
  "SLS01": "Алфатар",
  "SFO54": "Антон",
  "TGV02": "Антоново",
  "LOV02": "Априлци",
  "KRZ02": "Ардино",
  "PDV01": "Асеновград",
  "DOB03": "Балчик",
  "SML02": "Баните",
  "BLG01": "Банско",
  "PAZ03": "Батак",
  "PVN03": "Белене",
  "BLG02": "Белица",
  "PAZ04": "Белово",
  "VID01": "Белоградчик",
  "VAR04": "Белослав",
  "MON02": "Берковица",
  "BLG03": "Благоевград",
  "KNL04": "Бобов дол",
  "KNL05": "Бобошево",
  "SFO06": "Божурище",
  "VID03": "Бойница",
  "MON04": "Бойчиновци",
  "JAM03": "Болярово",
  "SML05": "Борино",
  "VRC05": "Борован",
  "RSE03": "Борово",
  "SFO07": "Ботевград",
  "SZR04": "Братя Даскалови",
  "PAZ06": "Брацигово",
  "VID06": "Брегово",
  "PER08": "Брезник",
  "PDV07": "Брезово",
  "MON07": "Брусарци",
  "BGS04": "Бургас",
  "RSE04": "Бяла",
  "VAR05": "Бяла",
  "VRC08": "Бяла Слатина",
  "VAR06": "Варна",
  "SHU23": "Велики Преслав",
  "VTR04": "Велико Търново",
  "PAZ08": "Велинград",
  "SHU07": "Венец",
  "RSE05": "Ветово",
  "VAR08": "Ветрино",
  "VID09": "Видин",
  "VRC10": "Враца",
  "MON11": "Вълчедръм",
  "VAR09": "Вълчи дол",
  "SHU10": "Върбица",
  "MON12": "Вършец",
  "GAB05": "Габрово",
  "DOB12": "Генерал Тошево",
  "MON14": "Георги Дамяново",
  "SLS07": "Главиница",
  "SFO09": "Годеч",
  "SFO10": "Горна Малина",
  "VTR06": "Горна Оряховица",
  "BLG11": "Гоце Делчев",
  "VID15": "Грамада",
  "PVN08": "Гулянци",
  "SZR37": "Гурково",
  "SZR07": "Гълъбово",
  "BLG13": "Гърмен",
  "RSE08": "Две могили",
  "SML09": "Девин",
  "VAR14": "Девня",
  "KRZ08": "Джебел",
  "HKV09": "Димитровград",
  "VID16": "Димово",
  "DOB15": "Добрич-селска",
  "DOB28": "Добрич",
  "SFO59": "Долна баня",
  "PVN10": "Долна Митрополия",
  "PVN11": "Долни Дъбник",
  "VAR13": "Долни чифлик",
  "SML10": "Доспат",
  "SFO16": "Драгоман",
  "GAB12": "Дряново",
  "SLS10": "Дулово",
  "KNL48": "Дупница",
  "VAR16": "Дългопол",
  "VTR13": "Елена",
  "SFO17": "Елин Пелин",
  "JAM07": "Елхово",
  "SFO18": "Етрополе",
  "RAZ11": "Завет",
  "PER19": "Земен",
  "VTR14": "Златарица",
  "SFO47": "Златица",
  "SML11": "Златоград",
  "HKV11": "Ивайловград",
  "RSE13": "Иваново",
  "PVN23": "Искър",
  "RAZ14": "Исперих",
  "SFO20": "Ихтиман",
  "DOB17": "Каварна",
  "SZR12": "Казанлък",
  "SLS15": "Кайнарджа",
  "PDV12": "Калояново",
  "BGS08": "Камено",
  "SHU18": "Каолиново",
  "PDV13": "Карлово",
  "BGS09": "Карнобат",
  "SHU19": "Каспичан",
  "KRZ14": "Кирково",
  "PVN39": "Кнежа",
  "PER22": "Ковачевци",
  "VRC20": "Козлодуй",
  "SFO24": "Копривщица",
  "SFO25": "Костенец",
  "SFO26": "Костинброд",
  "SLV11": "Котел",
  "KNL27": "Кочериново",
  "BLG28": "Кресна",
  "VRC21": "Криводол",
  "PDV39": "Кричим",
  "KRZ15": "Крумовград",
  "DOB20": "Крушари",
  "RAZ16": "Кубрат",
  "PDV42": "Куклен",
  "VID22": "Кула",
  "KRZ16": "Кърджали",
  "KNL29": "Кюстендил",
  "PVN16": "Левски",
  "PAZ14": "Лесичово",
  "LOV17": "Летница",
  "LOV18": "Ловеч",
  "RAZ17": "Лозница",
  "MON24": "Лом",
  "LOV19": "Луковит",
  "PDV15": "Лъки",
  "HKV17": "Любимец",
  "VTR20": "Лясковец",
  "SML16": "Мадан",
  "HKV18": "Маджарово",
  "VID25": "Макреш",
  "BGS12": "Малко Търново",
  "PDV17": "Марица",
  "MON26": "Медковец",
  "VRC27": "Мездра",
  "VRC28": "Мизия",
  "HKV19": "Минерални бани",
  "SFO56": "Мирково",
  "KRZ21": "Момчилград",
  "MON29": "Монтана",
  "SZR22": "Мъглиж",
  "KNL31": "Невестино",
  "SML18": "Неделино",
  "BGS15": "Несебър",
  "SHU21": "Никола Козлево",
  "SZR38": "Николаево",
  "PVN21": "Никопол",
  "SLV16": "Нова Загора",
  "SHU22": "Нови пазар",
  "VID30": "Ново село",
  "TGV22": "Омуртаг",
  "TGV23": "Опака",
  "SZR23": "Опан",
  "VRC31": "Оряхово",
  "SZR24": "Павел баня",
  "VTR22": "Павликени",
  "PAZ19": "Пазарджик",
  "PAZ20": "Панагюрище",
  "PER32": "Перник",
  "PDV40": "Перущица",
  "BLG33": "Петрич",
  "PAZ21": "Пещера",
  "SFO55": "Пирдоп",
  "PVN24": "Плевен",
  "PDV22": "Пловдив",
  "VTR26": "Полски Тръмбеш",
  "BGS17": "Поморие",
  "TGV24": "Попово",
  "PVN27": "Пордим",
  "SFO34": "Правец",
  "BGS27": "Приморско",
  "VAR24": "Провадия",
  "PDV23": "Първомай",
  "SZR27": "Раднево",
  "PER36": "Радомир",
  "RAZ26": "Разград",
  "BLG37": "Разлог",
  "PAZ24": "Ракитово",
  "PDV25": "Раковски",
  "KNL38": "Рила",
  "PDV26": "Родопи",
  "VRC32": "Роман",
  "SML27": "Рудозем",
  "BGS18": "Руен",
  "VID33": "Ружинци",
  "RSE27": "Русе",
  "PDV28": "Садово",
  "SFO39": "Самоков",
  "RAZ29": "Самуил",
  "BLG40": "Сандански",
  "KNL41": "Сапарева баня",
  "BLG42": "Сатовча",
  "HKV28": "Свиленград",
  "VTR28": "Свищов",
  "SFO43": "Своге",
  "GAB29": "Севлиево",
  "PAZ29": "Септември",
  "SLS31": "Силистра",
  "HKV29": "Симеоновград",
  "BLG44": "Симитли",
  "SLS32": "Ситово",
  "SLV20": "Сливен",
  "SFO45": "Сливница",
  "RSE33": "Сливо поле",
  "SML31": "Смолян",
  "SHU25": "Смядово",
  "BGS21": "Созопол",
  "PDV43": "Сопот",
  "SOF46": "Столична",
  "BGS06": "Средец",
  "PDV41": "Стамболийски",
  "HKV30": "Стамболово",
  "SZR31": "Стара Загора",
  "VTR31": "Стражица",
  "JAM22": "Стралджа",
  "PAZ32": "Стрелча",
  "BLG49": "Струмяни",
  "VAR26": "Суворово",
  "BGS23": "Сунгурларе",
  "VTR32": "Сухиндол",
  "PAZ39": "Сърница",
  "PDV33": "Съединение",
  "SLV24": "Твърдица",
  "DOB27": "Тервел",
  "LOV33": "Тетевен",
  "HKV32": "Тополовград",
  "KNL50": "Трекляно",
  "LOV34": "Троян",
  "PER51": "Трън",
  "GAB35": "Трявна",
  "JAM25": "Тунджа",
  "SLS34": "Тутракан",
  "TGV35": "Търговище",
  "LOV36": "Угърчин",
  "BLG52": "Хаджидимово",
  "VRC35": "Хайредин",
  "HKV33": "Харманли",
  "HKV34": "Хасково",
  "PDV37": "Хисаря",
  "SHU11": "Хитрино",
  "RAZ36": "Цар Калоян",
  "BGS13": "Царево",
  "RSE37": "Ценово",
  "SFO57": "Чавдар",
  "SFO58": "Челопеч",
  "SML38": "Чепеларе",
  "PVN37": "Червен бряг",
  "KRZ35": "Черноочене",
  "MON36": "Чипровци",
  "SZR36": "Чирпан",
  "VID37": "Чупрене",
  "DOB29": "Шабла",
  "SHU30": "Шумен",
  "LOV38": "Ябланица",
  "MON38": "Якимово",
  "BLG53": "Якоруда",
  "JAM26": "Ямбол"
};

export const getMunicipalityName = (code) => {
  return MUNICIPALITY_NAMES[code] || code;
};